export const EXSBPOSITION_CREATE_RESET = 'EXSBPOSITION_CREATE_RESET'
export const EXSBPOSITION_CREATE_SET_CREATED = 'EXSBPOSITION_CREATE_SET_CREATED'
export const EXSBPOSITION_CREATE_SET_ERROR = 'EXSBPOSITION_CREATE_SET_ERROR'
export const EXSBPOSITION_CREATE_SET_VIOLATIONS = 'EXSBPOSITION_CREATE_SET_VIOLATIONS'
export const EXSBPOSITION_CREATE_TOGGLE_LOADING = 'EXSBPOSITION_CREATE_TOGGLE_LOADING'
